import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["icon", "iconTheme", "iconProps", "children", "className"];
import clsx from 'clsx';
import * as React from 'react';
import { Base } from '../../Base';
import Svg from '../../Svg';
var styles = {
  "root": "TypoListItem-root_3DYZa",
  "iconWrapper": "TypoListItem-iconWrapper_Zlm7Y",
  "icon": "TypoListItem-icon_3F-Kh"
};
function ListItem(_ref) {
  var icon = _ref.icon,
    iconTheme = _ref.iconTheme,
    iconProps = _ref.iconProps,
    children = _ref.children,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var theme = icon ? {
    flex: true,
    listStyleType: 'none'
  } : {};
  return /*#__PURE__*/React.createElement(Base, _extends({
    tagName: "li",
    className: clsx(styles.root, className)
  }, theme, extraProps), icon && Svg.has(icon) && /*#__PURE__*/React.createElement(Base, {
    tagName: "span",
    flex: true,
    flexAlignItemsCenter: true,
    className: styles.iconWrapper
  }, /*#__PURE__*/React.createElement(Svg, _extends({
    name: icon,
    theme: iconTheme,
    className: styles.icon
  }, iconProps))), children);
}
ListItem.displayName = 'TypoListItem';
export { ListItem };